export default {
  name: "zModalPinError",
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  methods: {}
};
